'use client';

import { Fragment } from 'react';
import { Pagination } from '@/app_components/common/Pagination';
import type { Pagination as PaginationInterface, PressReleaseListEntity } from '@/app_lib/types/EzNewswireApiEntities';
import { InListCTA } from './InListCTA';
import { PressReleaseCard } from './PressReleaseCard';

interface PressReleaseListProps {
  list: PressReleaseListEntity[];
  pagination: PaginationInterface;
  ctaUrl: string;
}

const inListCta = 5;

export const PressReleaseList = ({ list, pagination, ctaUrl }: PressReleaseListProps) => {
  return (
    <div className='flex flex-col gap-10 md:gap-6 lg:gap-10'>
      <div
        className='flex flex-col gap-6'
        data-cy='ez-newswire-press-releases-list'
      >
        {list.map((card, i) => (
          <Fragment key={card.title}>
            <PressReleaseCard
              date={card.publishDate}
              excerpt={card.excerpt || ''}
              headline={card.title}
              location={card.location}
              thumbnail={card.image?.url || ''}
              url={card.slug}
            />
            {i + 1 === inListCta && <InListCTA ctaUrl={ctaUrl} />}
          </Fragment>
        ))}
      </div>
      <div
        className='flex justify-center w-full'
        data-cy='ez-newswire-list-pagination'
      >
        <Pagination
          currentPage={pagination.currentPage}
          href='/press-releases'
          onPageChange={() => {}}
          removePageOnFirst
          totalPages={pagination.totalPages}
        />
      </div>
    </div>
  );
};
